import moment from 'moment';
import React from 'react'
import { Table } from 'react-frontier2';
import { Link } from 'react-router-dom';

export interface UserLogProps {
	fitted?: boolean,
	last?: boolean,
	titleSize?: 'big' | 'normal' | 'small',
	user: {
		user_id?: number,
		user_creator?: any,
		user_creator_name?: string,
		date_created?: number,

		approved?: boolean,
		user_approved?: number,
		user_approved_name?: string,
		date_approved?: number,

		verified?: boolean,
		user_verified?: number,
		user_verified_name?: string,
		date_verified?: number,

		completed?: boolean,
		user_completed?: number,
		user_completed_name?: string,
		date_completed?: number,

		cancelled?: boolean,
		user_cancelled?: number,
		user_cancelled_name?: string,
		date_cancelled?: number,

		deleted?: boolean,
		user_deleted?: number,
		user_deleted_name?: string,
		date_deleted?: number,

		paid?: boolean,
		user_paid?: number,
		user_paid_name?: string,
		date_paid?: number,

		// [key: string]: any,
	},
	style?: React.CSSProperties
}

export default function UserLog(props: UserLogProps) {
	const user = props.user;
	if(!user) return null;

	return (
		<Table details striped
			fitted={props.fitted}
			style={!props.fitted ? { maxWidth: 400, margin: 'auto', marginTop: 15, ...props.style } : props.style}
			className={props.fitted ? (props.last!==false ? 'last' : null) : (props.last ? 'last' : null)}
		>
			<Table.Head 
				title={!props.fitted ? "Usuarios" : null}
				titleSize={props.titleSize}
			/>
			<Table.Body>
				{!!(user.user_id || user.user_creator) && <Table.Row data={(
					['Creado', <>
						<Link target='_blank' className='normal' to={`/users/${(user.user_id || user.user_creator)}`}>
							{user.user_creator_name || `Usuario #${(user.user_id || user.user_creator)}`}
						</Link>
						{(user.user_id || user.user_creator) && (
							<div className="meta">ID: {(user.user_id || user.user_creator)}</div>
						)}
					</>]
				)} />}
				<Table.Row data={(
					['Fecha creación', <>
						{moment.unix(user.date_created).format('DD/MMM/YY HH:mm')}
					</>]
				)} />
				{(!!user.approved && <>
					<Table.Row data={(
						['Aprobado', <>
							<Link target='_blank' className='normal' to={`/users/${user.user_approved}`}>{user.user_approved_name || `Usuario #${user.user_approved}`}</Link>
							<div className="meta">ID: {user.user_approved}</div>
						</>]
					)} />
					<Table.Row data={(
						['Fecha aprobación', <>
							{moment.unix(user.date_approved).format('DD/MMM/YY HH:mm')}
						</>]
					)} />
				</>)}
				{!!user.completed && <>
					<Table.Row data={(
						['Completado', <>
							<Link target='_blank' className='normal' to={`/users/${user.user_completed}`}>{user.user_completed_name || `Usuario #${user.user_completed}`}</Link>
							<div className="meta">ID: {user.user_completed}</div>
						</>]
					)} />
					<Table.Row data={(
						['Fecha completada', <>
							{moment.unix(user.date_completed).format('DD/MMM/YY HH:mm')}
						</>]
					)} />
				</>}
				{!!user.paid && <>
					{!!user.user_paid && (
						<Table.Row data={(
							['Pagado', <>
								<Link target='_blank' className='normal' to={`/users/${user.user_paid}`}>{user.user_paid_name || `Usuario #${user.user_completed}`}</Link>
								<div className="meta">ID: {user.user_paid}</div>
							</>]
						)} />
					)}
					<Table.Row data={(
						['Fecha pagado', <>
							{moment.unix(user.date_paid).format('DD/MMM/YY HH:mm')}
						</>]
					)} />
				</>}
				{!!user.cancelled && <>
					<Table.Row data={(
						['Cancelado', <>
							<Link target='_blank' className='normal' to={`/users/${user.user_cancelled}`}>{user.user_cancelled_name || `Usuario #${user.user_cancelled}`}</Link>
							<div className="meta">ID: {user.user_cancelled}</div>
						</>]
					)} />
					<Table.Row data={(
						['Fecha cancelado', <>
							{moment.unix(user.date_cancelled).format('DD/MMM/YY HH:mm')}
						</>]
					)} />
				</>}
				{!!user.deleted && <>
					<Table.Row data={(
						['Eliminado', <>
							<Link target='_blank' className='normal' to={`/users/${user.user_deleted}`}>{user.user_deleted_name || `Usuario #${user.user_deleted}`}</Link>
							<div className="meta">ID: {user.user_deleted}</div>
						</>]
					)} />
					<Table.Row data={(
						['Fecha eliminado', <>
							{moment.unix(user.date_deleted).format('DD/MMM/YY HH:mm')}
						</>]
					)} />
				</>}
			</Table.Body>
		</Table>
	)
}
